import {
  Button,
  List,
  ListItem,
  ListItemButton,
  Paper,
  Popover,
} from "@mui/material";
import { ReactNode, useState } from "react";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import theme from "../../theme";

interface ButtonWithSelectProps {
  options: any;
  toTrim?: boolean;
  fullWidth?: boolean;
  value: string | undefined;
  onChange: (value: string | null) => void;
  rightIcon: ReactNode;
  label: string;
  w?: string | number;
  children?: any;
  onOpenChange?: (open: boolean) => void;
  style?: any;
}

const ButtonWithOptions = ({
  rightIcon,
  options,
  value,
  onChange,
  label,
  toTrim = true,
  fullWidth = true,
  children,
  w = "280px",
  onOpenChange,
  style = {},
}: ButtonWithSelectProps & { onOpenChange?: (open: boolean) => void }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);

  const handleOpenChange = (newAnchorEl: HTMLButtonElement | null) => {
    setAnchorEl(newAnchorEl);
    onOpenChange?.(Boolean(newAnchorEl));
  };

  return (
    <>
      {/* <Grid container spacing={2}>
        <Grid item xs={2}>
          {rightIcon}{" "}
        </Grid>
        <Grid item xs={8}>
          {label}
        </Grid>
        <Grid item xs={2}>
          {<ExpandMoreOutlinedIcon />}
        </Grid>
      </Grid> */}
      <Button
        sx={{ ...style, borderRadius: 7 }}
        fullWidth={fullWidth}
        startIcon={rightIcon}
        endIcon={<ExpandMoreOutlinedIcon />}
        variant="outlined"
        onClick={(e) => handleOpenChange(e.currentTarget)}
      >
        {label?.length > 15 && toTrim ? `${label.slice(0, 15)}...` : label}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => handleOpenChange(null)}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
      >
        <Paper sx={{ width: w }}>
          {/* <Box
            sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}
          > */}
          <List>
            {options?.map((o: any) => (
              <ListItem disablePadding key={o?.label}>
                <ListItemButton
                  onClick={() => {
                    onChange(o?.deviceId);
                    handleOpenChange(null);
                  }}
                >
                  <ListItemText
                    primary={o?.label}
                    sx={{
                      color:
                        value === o.deviceId
                          ? theme.palette.primary.main
                          : undefined,
                    }}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
          {children}
          {/* </Box> */}
        </Paper>
      </Popover>
    </>
  );
};

export default ButtonWithOptions;
